import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import { categories } from "@/mocks/site";

export default function CategoryGrid() {
  return (
    <section className="bg-background-100 py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-8">
        <SectionHeading
          eyebrow="主题分类"
          title="按事件类型回头查"
          desc="同类事件往往有相似的发酵路径。按分类回溯，更容易看清那些反复出现的规律。"
        />

        <div className="mt-9 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((category) => (
            <Link
              key={category.slug}
              to={`/events?category=${category.slug}`}
              className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-6 transition-colors hover:border-primary-300"
            >
              <div className="flex items-center justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-primary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className={`${category.icon} text-xl`}></i>
                </span>
                <span className="text-xs text-foreground-400">{category.count} 篇复盘</span>
              </div>
              <h3 className="mt-5 font-heading text-lg font-bold text-foreground-950 transition-colors group-hover:text-primary-600">
                {category.name}
              </h3>
              <p className="mt-2 text-sm leading-6 text-foreground-600">{category.desc}</p>
              <span className="mt-5 inline-flex items-center gap-1 text-sm text-secondary-700">
                查看该分类
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5"></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}